import { configureAuthFailureRedirect } from "../Api/apiFetch";
import { configureTokenRefresh } from "../Api/tokenRefresh";
import { configureLogout } from "./logout";

export interface AuthConfig {
  picoComApiUrl: string;
  loginUrl: string;
  onPostLogout?: () => void;
}

export function configureAuth(config: AuthConfig): void {
  configureTokenRefresh({ refreshUrl: `${config.picoComApiUrl}/auth/refresh` });
  configureLogout({
    picoComApiUrl: config.picoComApiUrl,
    onPostLogout:
      config.onPostLogout ??
      (() => {
        window.location.href = config.loginUrl;
      }),
  });
  configureAuthFailureRedirect(() => {
    const returnTo = encodeURIComponent(window.location.href);
    window.location.href = `${config.loginUrl}?returnTo=${returnTo}`;
  });
}
